module.exports = __webpack_public_path__ + "static/media/cases_impressos_kelloggs_01b.48576fc7.jpg";